/**
 * A language's name as a language picker shows it: `culture` named in `inLocale`, with its first
 * letter capitalized. `Intl.DisplayNames` answers with the form a name takes mid-sentence, which is
 * lowercase in Spanish, French and Italian ("español", "français", "italiano"); CLDR's own rule for
 * a menu or a list is to capitalize the first word, which `Intl` does not apply. A regional
 * variant reads "Deutsch (Schweiz)" in every runtime: the default dialect names differ with the
 * ICU data a browser ships ("Schweizer Hochdeutsch" with the full set). The code where
 * Intl.DisplayNames is missing or rejects the locale.
 */
export function languageName(culture: string, inLocale: string): string {
  let name: string | undefined;
  try {
    name = new Intl.DisplayNames([inLocale], { type: "language", languageDisplay: "standard" }).of(culture);
  } catch {
    return culture;
  }
  if (!name) return culture;
  return name.charAt(0).toLocaleUpperCase(inLocale) + name.slice(1);
}
